import { ALGORITHMS } from '../VerticalCards/verticalCardsConstants';
import { selectVertical } from '../Components/Filter/FiltersSlice';
import store from '../../store';

// Keyed on the vertical picked in the study list, not the series: the default series carries no schema.
// filters.vertical is not persisted, so after a reload the report shows again (same limit as Title.js).

// Whether the report panel stays hidden on this vertical; absent means show it.
export const isReportlessVertical = vertical =>
  Boolean(vertical) && vertical.name === ALGORITHMS.AZNODE;

// Single store read for this rule, so the toolbar button and the panel on mount agree.
export const isReportHiddenHere = () =>
  isReportlessVertical(selectVertical(store.getState()));
